import Dataman from 'App/Dataman';
import { sortAsc } from 'App/utils/Helpers';

export async function loadCategories() {
  const { data } = await Dataman.DB.categories.getReadable({
    params: { itemsPerPage: 100 },
  });
  return data.sort(() => sortAsc('name'));
}
